var vt = {
  mn: function mn() {
    return "serviceWorker" in navigator && "undefined" != typeof ServiceWorkerRegistration && "showNotification" in ServiceWorkerRegistration.prototype && "PushManager" in window;
  },
  vn: function vn() {
    return "safari" in window && "pushNotification" in window.safari && "function" == typeof window.safari.pushNotification.permission && "function" == typeof window.safari.pushNotification.requestPermission;
  },
  isPushSupported: function isPushSupported() {
    return vt.mn() || vt.vn();
  },
  isPushBlocked: function isPushBlocked() {
    var i = vt.isPushSupported() && "Notification" in window && null != window.Notification && null != window.Notification.permission && "denied" === window.Notification.permission,
        n = vt.isPushSupported() && (!("Notification" in window) || null == window.Notification);
    return i || n;
  },
  isPushPermissionGranted: function isPushPermissionGranted() {
    return vt.isPushSupported() && "Notification" in window && null != window.Notification && null != window.Notification.permission && "granted" === window.Notification.permission;
  },
  Tr: function Tr() {
    return !vt.isPushBlocked() && vt.isPushSupported() && !vt.isPushPermissionGranted();
  }
};
export default vt;